

export type Meta = {
  name: string
}

export const DefaultMeta: Meta = {
  name: ""
}
